import React, { Component, ReactNode } from 'react';
import { observer } from 'mobx-react';
import autoBindMethods from 'class-autobind-decorator';
import ReactTable from 'react-table';

import { Well } from 'react-bootstrap';

import { ILoanComplianceCharge } from '../../../interfaces';

import { COMPLIANCE_CHARGE_COLUMNS } from './Columns';

// Newest period first, as the feed and the payments table are also ordered
const DEFAULT_SORTED = [{ desc: true, id: 'due_date' }];

interface IProps {
  charges: ILoanComplianceCharge[];
  // Shares the title's row, as the loans table does
  newButton?: ReactNode;
}

@autoBindMethods
@observer
class ComplianceChargesTable extends Component<IProps> {
  private renderTable () {
    const { charges } = this.props;

    // Charges only start once the account's first loan has been originated for a quarter, so a new
    // account sits empty for a while. Say so rather than showing bare column headers.
    if (!charges.length) {
      return (
        <div className='empty'>
          There are no compliance charges for this account yet.
        </div>
      );
    }

    return (
      <ReactTable
        columns={COMPLIANCE_CHARGE_COLUMNS}
        data={charges}
        defaultSorted={DEFAULT_SORTED}
        keyField='id'
        minRows={0}
        pageSize={charges.length}
        resizable={false}
        showPagination={false}
        sortable
      />
    );
  }

  public render () {
    return (
      <Well className='compliance-charges-list well-table'>
        <h3 className='flex-between'>
          Compliance Charges
          {this.props.newButton}
        </h3>
        {this.renderTable()}
      </Well>
    );
  }
}

export default ComplianceChargesTable;
